import type { AdminSetting, AdminSettingValue } from '@api/admin-settings';

export const NOT_AVAILABLE = 'This page is not available.';
export const FAILED_MESSAGE = 'Something went wrong. Try again.';

/** What the editor holds while an admin types: always text. */
export const toDraft = (setting: AdminSetting, value: AdminSettingValue) =>
  setting.type === 'string_list' && Array.isArray(value)
    ? value.join('\n')
    : String(value ?? '');

/** The value sent to the server, or null when the text is not a value. */
export const fromDraft = (
  setting: AdminSetting,
  draft: string
): AdminSettingValue | null => {
  if (setting.type === 'string_list') {
    return draft
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
  }
  if (setting.type === 'number') {
    if (!/^-?\d+$/.test(draft.trim())) return null;
    return Number(draft.trim());
  }
  return draft;
};

/** How a logged value reads in the change log. */
export const formatValue = (value: AdminSettingValue | null): string => {
  if (value === null || value === undefined) return '(default)';
  if (Array.isArray(value)) return value.join('\n');
  return String(value);
};

/** The reason the server gave for refusing a request, in plain words. */
export const errorText = (err: unknown): string => {
  const response = (err as { response?: { status?: number; data?: any } })
    ?.response;
  if (response?.status === 403 || response?.status === 404) {
    return NOT_AVAILABLE;
  }
  if (response?.status === 400) {
    const reasons = response.data?.value;
    if (Array.isArray(reasons) && reasons.length) return reasons.join(' ');
    if (typeof response.data?.detail === 'string') return response.data.detail;
  }
  return FAILED_MESSAGE;
};
